import { types } from 'mobx-state-tree';
import DropoffLocation from './DropoffLocation';

export default types.model('VFDVirtualAccount', {
  account_number: types.string,
  reference: types.string,
  expires_at: types.string,
  status: types.string,
  bank_name: types.string,
  amount: types.string,
});
